var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncludedHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.784,
    height: 27.776,
    viewBox: "0 0 36.784 27.776",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "health-pack-icon",
    transform: "translate(0.4 -2.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34630",
    "data-name": "Path 34630",
    d: "M13.495,23.237a.75.75,0,0,1-.576-.27c-5.216-6.261-5.216-13.442,0-19.7a.775.775,0,0,1,1.151,0c5.216,6.261,5.216,13.442,0,19.7A.75.75,0,0,1,13.495,23.237Zm0-18.288c-4.011,5.3-4.011,11.038,0,16.334C17.505,15.988,17.505,10.245,13.495,4.95Z",
    transform: "translate(4.498 0)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34631",
    "data-name": "Path 34631",
    d: "M13.154,22.973a.75.75,0,0,1-.576-.27,17.812,17.812,0,0,1-2.832-4.619.749.749,0,1,1,1.387-.568,15.7,15.7,0,0,0,2.02,3.5,15.813,15.813,0,0,0,2.02-3.5.749.749,0,1,1,1.387.568A17.772,17.772,0,0,1,13.726,22.7a.74.74,0,0,1-.573.27Z",
    transform: "translate(4.839 7.012)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34632",
    "data-name": "Path 34632",
    d: "M12.258,21.229a.75.75,0,0,1-.067-1.5c7.125-.66,11.043-4.3,11.95-11.133a12.836,12.836,0,0,0-7.657,3.425.75.75,0,0,1-1.069-1.053C17.641,8.714,20.839,7.38,24.922,7a.742.742,0,0,1,.6.216.758.758,0,0,1,.217.6C25,15.96,20.49,20.471,12.33,21.226A.6.6,0,0,1,12.258,21.229Z",
    transform: "translate(5.747 1.993)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34633",
    "data-name": "Path 34633",
    d: "M20.505,21.987a14.3,14.3,0,0,1-8.711-3.318.749.749,0,1,1,.91-1.19c5.242,4.009,10.346,4.015,15.586.012A13.247,13.247,0,0,0,21.2,14.534a.751.751,0,0,1-.7-.8.729.729,0,0,1,.8-.7,15.274,15.274,0,0,1,8.675,3.874.749.749,0,0,1,0,1.153C26.834,20.68,23.669,21.987,20.505,21.987Z",
    transform: "translate(5.742 5.007)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34634",
    "data-name": "Path 34634",
    d: "M9.737,21.987c-3.164,0-6.329-1.307-9.467-3.922a.749.749,0,0,1,0-1.153,15.274,15.274,0,0,1,8.675-3.874.73.73,0,0,1,.8.7.75.75,0,0,1-.7.8,13.249,13.249,0,0,0-7.093,2.957c5.237,4,10.344,4,15.586-.012a.749.749,0,1,1,.91,1.19,14.31,14.31,0,0,1-8.711,3.318Z",
    transform: "translate(0 5.007)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34635",
    "data-name": "Path 34635",
    d: "M16.481,21.229a.553.553,0,0,1-.07,0C8.251,20.471,3.739,15.959,3,7.818a.749.749,0,0,1,.217-.6A.735.735,0,0,1,3.819,7c4.083.375,7.279,1.711,9.507,3.969a.75.75,0,0,1-1.069,1.053A12.85,12.85,0,0,0,4.6,8.6c.906,6.828,4.825,10.473,11.95,11.133a.75.75,0,0,1-.067,1.5Z",
    transform: "translate(1.498 1.993)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncludedHealth);
export default __webpack_public_path__ + "static/media/includedHealth.c7611d4122672c710e371eafb6c0e4d8.svg";
export { ForwardRef as ReactComponent };